import React from 'react'
import styled from 'styled-components'

const LabelContainer = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: ${props => (props.selected ? '#ffffff' : '#ffffff')};
  background-color: ${props => (props.selected ? '#646669' : '#13294b')};

  @media (max-width: 420px) {
    font-size: 12px;
  }
`

const Label = props => (
  <LabelContainer selected={props.selected}>{props.label}</LabelContainer>
)

export default Label
